export const percent = (statValue: number, total: number) => {
    return statValue === 0 ? 0 : (statValue / total) * 100;
};
